(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sf-reviews"] && !Shopify.designMode) return;
  try {
    
  class SfReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.sf-reviews__track');
      this.bar = this.querySelector('.sf-reviews__progress-bar');
      if (!this.track) return;
      this.arrows = this.querySelectorAll('.sf-reviews__arrow');
      this.arrows.forEach((btn) => {
        btn.addEventListener('click', () => this.step(btn.dataset.dir === 'next' ? 1 : -1));
      });
      this.track.addEventListener('scroll', () => this.schedule(), { passive: true });
      window.addEventListener('resize', () => this.schedule(), { passive: true });
      this.sync();
      this.setupAutoplay();
    }

    setupAutoplay() {
      const secs = parseFloat(this.dataset.autoplay || '0');
      if (!secs) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.delay = secs * 1000;
      this.paused = false;

      const hold = () => { this.paused = true; };
      const release = () => { this.paused = false; };
      this.addEventListener('mouseenter', hold);
      this.addEventListener('mouseleave', release);
      this.addEventListener('focusin', hold);
      this.addEventListener('focusout', release);
      this.track.addEventListener('pointerdown', () => { this.stopAutoplay(); }, { passive: true });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((es) => {
          this.visible = es[0].isIntersecting;
        }, { threshold: 0.35 });
        this.io.observe(this);
      } else {
        this.visible = true;
      }
      document.addEventListener('visibilitychange', () => {
        this.hidden_ = document.hidden;
      });

      this.timer = setInterval(() => {
        if (this.paused || this.hidden_ || this.visible === false) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= max - 1) {
          this.track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          this.step(1);
        }
      }, this.delay);
    }

    stopAutoplay() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
      if (this.io) { this.io.disconnect(); this.io = null; }
    }

    disconnectedCallback() { this.stopAutoplay(); }

    get pageWidth() {
      const card = this.track.querySelector('.sf-reviews__quote');
      if (!card) return this.track.clientWidth;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const per = Math.max(1, Math.round(this.track.clientWidth / (card.offsetWidth + gap)));
      return (card.offsetWidth + gap) * per;
    }

    step(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * this.pageWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
    }

    sync() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      const left = this.track.scrollLeft;
      if (this.bar) {
        const visible = max > 0 ? this.track.clientWidth / this.track.scrollWidth : 1;
        const ratio = max > 0 ? left / max : 0;
        this.bar.style.width = Math.max(visible * 100, 8) + '%';
        this.bar.style.transform = 'translateX(' + (ratio * (100 / Math.max(visible * 100, 8) * 100 - 100)) + '%)';
      }
      this.arrows.forEach((btn) => {
        const next = btn.dataset.dir === 'next';
        btn.disabled = next ? left >= max - 1 : left <= 1;
      });
    }
  }
  if (!customElements.get('sf-reviews-slider')) {
    customElements.define('sf-reviews-slider', SfReviewsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
